module.exports = __webpack_public_path__ + "static/img/img-top-app-sp.843061f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-top-app-sp.png
// module id = sBk4
// module chunks = 1